import React from "react";
import { Button } from "primereact/button";
import styled from "styled-components";

export interface ButtonProps {
  text?: string;
  icon?: string;
  iconPos?: string;
  color?: string;
  svg?: any;
  tooltip?: string;
  disabled?: boolean;
  linkUrl?: string;
  onClick?: () => void;
}

const Primary = styled(Button) <{ color: string }>`
  .p-button-label {
    color: ${(props) => (props.color ? props.color : "#dd052b")}!important;
  }

  :hover {
    .p-button-label {
      color: white !important;
    }
    background-color: #dd052b !important;
  }
  img{
    position:absolute;
  }
`;

const Secondary = styled(Button)`
  .p-button-icon-only,
  .p-button-label,
  .p-button-icon-left,
  .p-button-icon-right {
    color: #dd052b !important;
  }
  .p-button-icon-right {
    font-size:1.3rem!important;
  }
`;

const Link = styled.a`
 text-decoration: none !important;
  color: #dd052b !important;
  background: transparent !important;
  border: none !important;
  font: italic normal 300 16px/29px Roboto !important;
`;

const LinkB = styled.a`
 margin-right:1rem;
 padding:0.5rem 3rem;
 text-decoration: none !important;
  color: #dd052b !important;
  background: transparent !important;
  border: solid #dd052b 1px !important;
  border-radius:5px;
  :hover {
      color: white !important;
    background-color: #dd052b !important;
  }
  @media (max-width: 768px) {
    margin-right:0rem;
    display:block;
    }
`;

const Svg = styled.img`
  margin-left: 0.5rem;
  position: relative;
  top: -4px;
`;

export const PrimaryButton: React.FC<ButtonProps> = ({
  color,
  text,
  icon,
  disabled,
  onClick,
}) => (
  <Primary
    disabled={disabled ? disabled : false}
    color={color}
    label={text}
    style={{
      background: "transparent",
      border: `solid 1px ${color ? color : "#dd052b"}`,
      borderRadius: "4px",
      padding: ".5rem",
    }}
    onClick={onClick}
  >{icon ?
    <img src={icon} alt='' /> : null}
  </Primary>
);

export const SecondaryButton: React.FC<ButtonProps> = ({
  text,
  onClick,
  icon,
  iconPos,
  svg,
  tooltip,
  disabled,
}) => (
  <Secondary
    data-testid="secondary-button"
    icon={`pi pi-${icon}`}
    iconPos={iconPos ? iconPos : 'left'}
    label={text}
    style={{
      color: "#dd052b",
      background: "transparent",
      border: "none",
      padding: "1rem",
      font: "italic normal 300 16px/29px Roboto",
    }}
    tooltip={tooltip}
    onClick={onClick}
    disabled={disabled}
  >
    {svg && <Svg src={svg} alt="svg" />}
  </Secondary>
);

export const PrimaryLink: React.FC<ButtonProps> = ({
  text,
  linkUrl,
}) => (
  <LinkB
    data-testid="link-button-primary"
    href={linkUrl}
  >
    {text}
  </LinkB>
);

export const LinkButton: React.FC<ButtonProps> = ({
  text,
  linkUrl,
  icon
}) => (
  <Link
    data-testid="link-button"
    href={linkUrl}
  >
    {text} {icon ? <i className={`pi pi-${icon}`} /> : null}
  </Link>
);
